import { render, staticRenderFns } from "./PlanPackageDetails.vue?vue&type=template&id=24a69915&"
import script from "./PlanPackageDetails.vue?vue&type=script&lang=js&"
export * from "./PlanPackageDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports